document.addEventListener('DOMContentLoaded', (event) => {

    const element = document.querySelector('#category-search-form');
    //Filter toggler - start
    const afFilterResetButton = document.getElementById("af-reset-blog-filter-settings");
    const afFilterToggler = document.getElementById("af-toggle-blog-filter-settings");
    const afFilterPlaceholder = document.querySelectorAll(".bloq-overview-filter-list")[0];
    const afFilterTogglerArrow = document.getElementById("af-toggle-blog-filter-settings-arrow");

    function afToggleFilter(e) {
        if(e) {
            e.preventDefault();
        }
        afFilterPlaceholder.className = afFilterPlaceholder.className === "bloq-overview-filter-list" ? "bloq-overview-filter-list bloq-overview-filter-list-hidden" : "bloq-overview-filter-list";
        afFilterTogglerArrow.className = afFilterTogglerArrow.className === "" ? "af-toggle-blog-filter-settings-arrow-opened" : "";
    }
    if(typeof(element) != 'undefined' && element != null) {
        let numberOfSelectedFilters = 0;
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        let categories = [];
        if(urlParams.has("category")) {
            afFilterResetButton.style.display = "";
            categories = urlParams.get("category").split(",");
            const categoriesLength = categories.length;
            for (let i = 0; i < categoriesLength; i++) {
                if(document.getElementById(categories[i])){
                    document.getElementById(categories[i]).checked = true;
                    numberOfSelectedFilters++;
                }
            }
            const numberOfFiltersSpan = document.getElementById("af-toggle-blog-filter-settings-number");
            if(numberOfSelectedFilters > 0) {
                numberOfFiltersSpan.innerHTML = numberOfSelectedFilters + "";
            }
            else {
                numberOfFiltersSpan.style.display = "none";
            }
            afToggleFilter();
        }

        let categoryChecklist = document.querySelector('.category-checklist').textContent;
        let searchCategories = document.querySelectorAll(".bloq-overview-filter-list .bloq-overview-filter-item input");
        searchCategories.forEach(item => {
            if(!categoryChecklist.includes(item.id)){
                item.parentElement.parentElement.classList.add('hide');
            }
        });

        const filterListItems = document.querySelectorAll(".bloq-overview-filter-list .bloq-overview-filter-item");
        const filterListItemsLength = filterListItems.length;

        function afTriggerSearch(e,currentFilterItem) {
            e.preventDefault();
            const url = new URL(window.location.origin + window.location.pathname);
            url.search = '';
            const result = url.toString();
            const currentFilterItemInput = currentFilterItem.querySelectorAll("input")[0];
            //For desktop
            if (window.innerWidth > 767) {
                if (categories.indexOf(currentFilterItemInput.id) > -1) {
                    categories = categories.filter((a) => (a !== currentFilterItemInput.id)) ;
                }
                else {
                    categories.push(currentFilterItemInput.id);
                }
            }
            else {
                if (categories.indexOf(currentFilterItemInput.id) > -1) {
                    categories = [];
                }
                else {
                    categories = [currentFilterItemInput.id];
                }
            }
            let query = "";
            if (categories.length) {
                query = "?category=" + categories.toString()
            }
            window.open(result + query,"_self");
        }

        for (let i = 0; i < filterListItemsLength; i++) {
            (function() {
                const filterListItemsCurrent = filterListItems[i];
                filterListItemsCurrent.querySelectorAll("span")[0].addEventListener("click",function(){afTriggerSearch(event,filterListItemsCurrent)})
            })();
        }
    }

    afFilterToggler.addEventListener("click",afToggleFilter);
    //Filter toggler - end
    //Filter reset - start

    function afResetFilter(e) {
        e.preventDefault();
        const urlObj = new URL(window.location.origin + window.location.pathname);
        urlObj.search = '';
        const result = urlObj.toString();
        window.open(result,"_self");
    }
    afFilterResetButton.addEventListener("click",afResetFilter);
    //Filter reset - end


    const resultListWrapper = document.querySelector('.app-site-document-blog-list-wrapper');
    if(typeof(resultListWrapper) != 'undefined' && resultListWrapper != null) {

        let itemCount = document.querySelector('.app-site-document-blog-list-wrapper').getAttribute("data-list-count");
        let listItems = document.querySelectorAll('.app-site-component-blog-searchresult-teaser');
        let variationACount = Math.floor(itemCount / 5);

        let listWrapper = document.querySelector('.app-site-document-blog-list-wrapper');
        let itemCounter=0;
        let finish = 5;

        calculateVariationA(listItems, variationACount, listWrapper, itemCounter, finish);
        let firstBoxes = document.querySelectorAll('.variation-type .app-site-component-blog-searchresult-teaser');
        firstBoxes.forEach( item => {
            if(item.querySelector('.content p')) {
                if (item.querySelector('.content p').offsetHeight > item.querySelector('.content').offsetHeight) {
                    item.classList.add('dots-content');
                }
            }
            if(item.querySelector('.headline h2')) {
                if (item.querySelector('.headline h2').offsetHeight > item.querySelector('.headline').offsetHeight) {
                    item.classList.add('dots-headline');
                }
            }
        });
        if(window.innerWidth < 1024){
            document.querySelector('.app-site-component-blog-searchresult-teaser-image picture source').setAttribute('media', '(max-width:640px)');
        }

        // add aos animation class to teaser elements
        listItems.forEach( function(listItem){
            listItem.classList.add('fade-in-aos');
        })

        // set animated class on teaser elements in viewport
        const elementsToFadeInUpOnScroll = document.querySelectorAll(".fade-in-aos");
        elementsToFadeInUpOnScroll.forEach( function(item){
            if(isElementXPercentInViewport(item, 15)){
                item.classList.add("fade-in");
            }
        });

        // set on scroll event, check if element is scrolled into view port and add animated class to start keyframe animation
        if (elementsToFadeInUpOnScroll) {
            window.addEventListener("scroll", function(event) {
                elementsToFadeInUpOnScroll.forEach(function(element) {
                    if ((window.scrollY - 200) >= (element.offsetTop - window.innerHeight)) {
                        if(isElementXPercentInViewport(element, 15)){
                            element.classList.add("fade-in");
                        }
                    }
                });
            });
        }
    }

    //Saving blog category in a sessionStorage in case it is selected so that it can be used as a URL in back to link
    //In case no category is selected and sessionStorage exists, it should be deleted
    function afSaveSelectedCategory() {
        const category = new URLSearchParams(window.location.search);
        if(category.has('category')) {
            const categoryArray = category.get('category');
            sessionStorage.setItem("blogCategory",categoryArray)
        }
        else {
            sessionStorage.removeItem("blogCategory")
        }
    }
    window.addEventListener("load",afSaveSelectedCategory);
})

function calculateVariationA(listItems, variationACount, listWrapper, itemCounter, finish){
    let disraptors = [];
    let forDeletion = [];
    if (document.querySelectorAll('.blog-overview-header-companies-article-only').length) {
        disraptors = document.querySelectorAll('.disruptors .app-site-disruptor-wrapper.app-site-disruptor-wrapper-company');
        forDeletion = document.querySelectorAll('.disruptors .app-site-disruptor-wrapper.app-site-disruptor-wrapper-all');
        if(forDeletion.length) {
            const forDeletionLength = forDeletion.length;
            for (let i = 0; i < forDeletionLength; i++) {
                (function() {
                    forDeletion[i].parentElement.removeChild(forDeletion[i]);
                })();
            }
        }
    }
    else {
        disraptors = document.querySelectorAll('.disruptors .app-site-disruptor-wrapper.app-site-disruptor-wrapper-all');
        forDeletion = document.querySelectorAll('.disruptors .app-site-disruptor-wrapper.app-site-disruptor-wrapper-company');
        if(forDeletion.length) {
            const forDeletionLength = forDeletion.length;
            for (let i = 0; i < forDeletionLength; i++) {
                (function() {
                    forDeletion[i].parentElement.removeChild(forDeletion[i]);
                })();
            }
        }
    }
    let disruptorCounter = 0;
    for (let i = 0; i <= variationACount; i++) {
        let currentItemLeft = document.querySelectorAll('.app-site-blog-search-result-list .app-site-component-blog-searchresult-teaser').length;
        if( currentItemLeft >= 5){
            let newNode = document.createElement('div');
            newNode.classList.add('blog-teaser-variation-'+i);
            newNode.classList.add('variation-type');
            for (let k = itemCounter; k < finish; k++) {
                newNode.appendChild(listItems[k]);
                itemCounter++;
            }
            finish = finish + 5;
            if(i === 0){
                listWrapper.prepend(newNode);
                document.querySelector('.app-site-document-blog-list-wrapper').classList.add('live');
                if(disraptors[disruptorCounter]) {
                    document.querySelector('.blog-teaser-variation-0').after(disraptors[disruptorCounter]);
                }
            }else {
                let nodes = document.querySelectorAll('.app-site-document-blog-list-wrapper >div');
                let lastNode = nodes[nodes.length- 2];
                if (disruptorCounter < disraptors.length){
                    lastNode.after(disraptors[disruptorCounter].cloneNode(true));
                }
                else {
                    disruptorCounter = 0;
                    if(disraptors[disruptorCounter]) {
                        lastNode.after(disraptors[disruptorCounter].cloneNode(true));
                    }
                }
                lastNode.after(newNode);
            }
        } else{
            document.querySelector('.app-site-document-blog-list-wrapper').classList.add('live');
        }
        disruptorCounter++;
    }
}

const isElementXPercentInViewport = function(el, percentVisible) {
    let
        rect = el.getBoundingClientRect(),
        windowHeight = (window.innerHeight || document.documentElement.clientHeight);

    return !(
        Math.floor(100 - (((rect.top >= 0 ? 0 : rect.top) / +-rect.height) * 100)) < percentVisible ||
        Math.floor(100 - ((rect.bottom - windowHeight) / rect.height) * 100) < percentVisible
    )
};



